/**
 * Enhanced 'a' tag that supports HTML5 pushstate.
 *
 * The problem:
 * with html5 push state, a tag like this: <a href="/login">Login</a> will cause
 * the browser to refresh.
 * Instead, what we usually want it to prevent default then call
 * router.navigate('/login', { trigger: true }).
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Link extends Component {
  static propTypes = {
    router: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
    }).isRequired,
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    style: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    style: {},
  };

  handleClick = (e) => {
    e.preventDefault();

    const {
      router,
      href,
    } = this.props;

    router.navigate(href, { trigger: true });
  };

  render() {
    const {
      className,
      href,
      children,
      style,
    } = this.props;

    return (
      <a className={className} href={href} onClick={this.handleClick} style={style}>
        {children}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Link.js